import React, { useEffect, useState } from "react";
import healthAuthImg2 from "../../assets/images/service/healthauth2.png";
import HealthDescription2 from "./HealthDescription2";
import TestApiModal from "../../component/modal/TestApiModal";
import TestAPiMobileModal from "../../component/modal/TestApiMobileModal";
import LoginModal from "../../component/modal/LoginModal";
import { handleModalController } from "../../util/Common";
const HealthService2 = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLoginModal, setLoginModal] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    // 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    handleModalController({
      windowWidth,
      setShowModal,
      setShowMobileModal,
      setLoginModal,
    });
  };

  return (
    <>
      <div
        className="row mt-5 sercice-details-content pb--80 align-items-center"
        id="health-2"
      >
        <div className="col-lg-6 col-12">
          <div className="thumb">
            <img className="w-100" src={healthAuthImg2} alt="Service Images" />
          </div>
        </div>
        <div className="col-lg-6 col-12">
          <div className="details mt_md--30 mt_sm--30">
            <h4 className="title">건강보험공단 공동인증서 인증 API</h4>
            <p>건강보험공단 로그인 시 공동인증서 인증을 요청할 수 있습니다.</p>

            <ul className="liststyle mt-4">
              <li>건강보험공단 로그인 시 공동인증서를 통한 로그인 지원</li>
              <li>건강보험공단에서 로그인 시 제공되는 기능을 활용 가능</li>
              <li>공동인증서 키 비밀번호 주민등록번호 입력 필요</li>
            </ul>
          </div>
          <div className="slide-btn mt-2">
            <a
              className="rn-button-style--2 btn-primary-color"
              style={{
                cursor: `pointer`,
              }}
              onClick={() => handleClick()}
            >
              신청하기
            </a>
          </div>
        </div>
      </div>
      <HealthDescription2></HealthDescription2>
      <TestApiModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <TestAPiMobileModal
        isOpen={showMobileModal}
        onClose={() => setShowMobileModal(false)}
      />
      <LoginModal isOpen={isLoginModal} onClose={() => setLoginModal(false)} />
    </>
  );
};
export default HealthService2;
